import * as S from './styles';

export type ContentBoxTypes = {
  icon: React.ReactNode;
  title: string;
  text: React.ReactNode;
};

const ContentBox = ({ icon, title, text }: ContentBoxTypes) => (
  <S.Wrapper>
    <S.Icon>{icon}</S.Icon>
    <S.Title>{title}</S.Title>
    <S.Text>{text}</S.Text>
  </S.Wrapper>
);

export default ContentBox;
